import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

/* jquery */
declare var $: any;

@Component({
  selector: 'app-inv-shareholders',
  templateUrl: './inv-shareholders.component.html',
  styles: [
  ]
})
export class InvShareholdersComponent implements OnInit, OnDestroy {

  dataTitle;
  dataSection = [];
  yearAnnual;
  yearExtra;
  dataYearAnnual = [];
  dataYearExtra = [];
  dataAnnual;
  dataPerAnnual;
  dataExtra;
  dataPerExtra;
  isLang;
  isActivePdf;

  constructor(private apiService: ApiService, 
              private globalService: GlobalService,
              private router: Router) {
    this.globalService.isLoading.next(true); 
  }

  ngOnInit(): void {
    // MultiLanguage
   this.isLang =  this.apiService.isLang();

    // Content
    this.apiService.getDataApi('getMenuSection/general-meeting-of-shareholders').subscribe(response => {
      if(response.success) {
        this.dataTitle = response.data;
        this.dataSection = response.data.section;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      } else {
        this.router.navigate(['/not-found']);
      }
    });

    // docs
    this.apiService.getDataApi('getDocumentYear?category=17').subscribe(response => {
      this.dataAnnual = response.data;
      this.isActivePdf = response.isActive;
       response.data.forEach((i,x) => {
         if(i.year){
           this.dataYearAnnual.push(i.year);
         }
         this.yearAnnual = this.dataYearAnnual[0];
         if(this.yearAnnual == i.year){
           this.dataPerAnnual = i.content;
         }
       });
    });
    this.apiService.getDataApi('getDocumentYear?category=18').subscribe(response => {
      this.dataExtra = response.data;
       response.data.forEach((i,x) => {
         if(i.year){
           this.dataYearExtra.push(i.year);
         }
         this.yearExtra = this.dataYearExtra[0];
         if(this.yearExtra == i.year){
           this.dataPerExtra = i.content;
         }
       });
    });
  }

  valueChangedAnnual(event: string) {
    this.dataAnnual.forEach((i,x) => {
      if(i.year == event){
        this.dataPerAnnual = i.content;
      }
    });
  }
  
  valueChangedExtra(event: string) {
    this.dataExtra.forEach((i,x) => {
      if(i.year == event){
        this.dataPerExtra = i.content;
      }
    });
  }

  ngOnDestroy(){
    /* clear select2 */
    const selectOptionsContainer = $('.select2-container');
    selectOptionsContainer.removeClass('select2-container--open');
  }

}
